import { Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { isAuthenticated } from '../../services/Authentification/authentification';
import ContactPageContent from './Content';

interface Props {
  classes?: any;
}

const ContactPage = (props: Props) => {
  const { classes } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const authenticated = isAuthenticated();

  // getTheme from Layout component
  const [theme, setTheme] = useState<Theme>();

  return (
    <Layout authenticated={authenticated} passTheme={setTheme}>
      <ContactPageContent classes={classes} theme={theme}></ContactPageContent>
    </Layout>
  );
};

export default ContactPage;
